import React from 'react'
import FormSection from 'components/FormSection'
import MultiFieldsGroup from 'components/MultiFieldsGroup'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography'
import SelectField from 'components/SelectField'
import Grid from '@material-ui/core/Grid'
import AutoSuggestionInput from 'components/AutoSuggestionInput'
import { skills } from 'suggestions'
import InputLabel from '@material-ui/core/InputLabel';

const Skills = ({
  mutators
}) => (
  <FormSection
    title={(
      <Typography variant="h6" component="h2">
        Umiejętności 
      </Typography> 
    )}
  >
    <MultiFieldsGroup
      name='skills'
      mutators={mutators}
      label='umiejętność'
      fieldToPreview='title'
      renderFieldsGroup={(name, index) => (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
              Umiejętność
            </InputLabel>
            <AutoSuggestionInput
              name={`${name}.title`}
              type="text"
              suggestions={skills}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
              Poziom
            </InputLabel>
            <SelectField
              name={`${name}.level`}
              options={[
                {
                  value: "0",
                  label: "Nie pokazuj poziomu"
                },
                {
                  value: "1",
                  label: "*"
                },
                {
                  value: "2",
                  label: "**"
                },
                {
                  value: "3",
                  label: "***"
                },
                {
                  value: "4",
                  label: "****"
                },
                {
                  value: "5",
                  label: "*****"
                }
              ]}
            />
          </Grid>
        </Grid>
      )}
    />
  </FormSection>
)

export default Skills